function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M106,0C64.647,0,30,34.647,30,76c0,41.353,34.647,75,76,75c41.353,0,75-33.647,75-75C181,34.647,147.353,0,106,0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M467,0H287c-24.814,0-45,21.186-45,46v90c0,24.814,20.186,45,45,45h53.789l55.605,55.605 c4.33,4.33,10.816,5.561,16.348,3.252c5.61-2.314,9.258-7.793,9.258-13.857v-45h45c24.814,0,45-20.186,45-45V46 C512,21.186,491.814,0,467,0z M437,136H317c-8.291,0-15-6.709-15-15s6.709-15,15-15h120c8.291,0,15,6.709,15,15 S445.291,136,437,136z M437,76H317c-8.291,0-15-6.709-15-15s6.709-15,15-15h120c8.291,0,15,6.709,15,15S445.291,76,437,76z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M480.251,391c-18.938,18.499-44.752,30-73.251,30c-28.499,0-54.313-11.501-73.251-30C314.217,410.08,302,436.608,302,466 v31c0,8.291,6.709,15,15,15h180c8.291,0,15-6.709,15-15v-31C512,436.608,499.783,410.08,480.251,391z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M444.214,251.278c-4.834,7.114-11.684,12.865-20.032,16.309c-16.024,6.705-35.579,3.649-48.999-9.771l-6.138-6.138 C346.984,264.751,332,288.552,332,316c0,41.353,33.647,75,75,75c41.353,0,75-33.647,75-75 C482,288.252,466.676,264.249,444.214,251.278z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M227,331h-54.789l-55.605-55.605c-4.292-4.277-10.737-5.581-16.348-3.252C94.647,274.457,91,279.936,91,286v45H45 c-24.814,0-45,20.186-45,45v90c0,24.814,20.186,46,45,46h182c24.814,0,45-21.186,45-46v-90C272,351.186,251.814,331,227,331z  M196,466H75c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15h121c8.291,0,16,6.709,16,15C212,459.291,204.291,466,196,466z  M196,406H75c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15h121c8.291,0,16,6.709,16,15C212,399.291,204.291,406,196,406z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M179.251,151c-18.939,18.499-44.753,30-73.251,30c-28.498,0-55.313-11.501-74.251-30C12.217,170.08,0,196.608,0,226v30 c0,8.291,6.709,15,15,15h47.807c4.18-11.796,13.964-21.617,26.01-26.587c16.241-6.742,35.636-3.538,48.97,9.727L154.642,271H196 c8.291,0,16-6.709,16-15v-30C212,196.608,198.783,170.08,179.251,151z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

function SvgControversial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControversial);
export default __webpack_public_path__ + "static/media/controversial.95ba62cf.svg";
export { ForwardRef as ReactComponent };